module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-footer.21912228.png";